import { Box } from "@chakra-ui/react";
import Script from "next/script";

interface Props {
  whiteText?: boolean;
}

export default function SenjaTestimonialsSmall({ whiteText }: Props) {
  return (
    <Box id="senja-testimonials" overflowX="hidden" w="270px">
      {whiteText ? (
        <>
          <Box
            w="300px"
            className="senja-embed"
            data-id="02432e36-4596-495c-b0c0-927e1f889195"
            data-mode="shadow"
            data-lazyload="false"
          ></Box>
          <Script
            src="https://widget.senja.io/widget/02432e36-4596-495c-b0c0-927e1f889195/platform.js"
            strategy="lazyOnload"
          />
        </>
      ) : (
        <>
          <Box
            w="300px"
            className="senja-embed"
            data-id="b7414eb1-89a0-4929-8657-5b05dbabcaad"
            data-mode="shadow"
            data-lazyload="false"
          ></Box>
          <Script
            src="https://widget.senja.io/widget/b7414eb1-89a0-4929-8657-5b05dbabcaad/platform.js"
            strategy="lazyOnload"
          />
        </>
      )}
    </Box>
  );
}
